import { useState, useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom';
import Headers from './Headers';
import { FixedSizeList as List } from 'react-window'; // Using react-window
import Axios from '../api/axios';
import '../App.css';

const SalesReport = () => {
  let navigate = useNavigate();
  const firstUserLoggedInSessionExpired = localStorage.getItem('loggedIn');
  let secondUserLoggedInSessionExpired = JSON.parse(firstUserLoggedInSessionExpired);

  useEffect(() => {
    if (secondUserLoggedInSessionExpired === 'No') {
      navigate('/Logout');
    }
  }, [navigate, secondUserLoggedInSessionExpired]);

  const server_app_api_php = window.SERVER_APP_API_PHP;

  const [DBtableViewSalesReport, setDBtableViewSalesReport] = useState([]);
  const [tableRefresh, setTableRefresh] = useState('');
  const [loading, setLoading] = useState(true);
  let [handleSubmitBtnDelete, setHandleSubmitBtnDelete] = useState('')

  const firstSystemSetupID = localStorage.getItem('systemSetupID');
  const systemSetupIDInitial = JSON.parse(firstSystemSetupID);

  const firstUserRole = localStorage.getItem('userRole')
  let secondUserRole = JSON.parse(firstUserRole)

  const firstUserID = localStorage.getItem('userID')
  let secondUserID = JSON.parse(firstUserID)

  const firstUserPosition = localStorage.getItem('userPosition');
  let secondUserPosition = JSON.parse(firstUserPosition);

  const fetchSalesReport = () => {
    setLoading(true);
    const formDataSalesReport = new FormData();
    formDataSalesReport.append('apiType', 'getViewSalesReport');
    if (secondUserPosition === 'Business Owner' || secondUserPosition === 'Auditor') {
      formDataSalesReport.append('businessNameID', systemSetupIDInitial);
    }
    if (secondUserPosition === 'Manager') {
      formDataSalesReport.append('businessBranchID', localStorage.getItem('systemSetupBranchID'));
    }
    if (secondUserPosition === 'Cashier') {
      formDataSalesReport.append('businessBranchIDCashier', localStorage.getItem('systemSetupBranchID'));
      formDataSalesReport.append('userID', localStorage.getItem('userID'));
    }

    Axios.post(`${server_app_api_php}/sales_report.php`, formDataSalesReport, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => {
      console.log('Data received from the server = ', response.data);
      setDBtableViewSalesReport(response.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchSalesReport();
  }, [tableRefresh]);

  const deleteRecord = posID => {
    setHandleSubmitBtnDelete('Loading')
    //const deleteSale = posID => {
    var formDataDeleteOneUser = new FormData(this)
    formDataDeleteOneUser.append('apiType', 'getViewSalesReport')
    formDataDeleteOneUser.append('posIDToDelete', posID)
    formDataDeleteOneUser.append('positionToDelete', secondUserPosition)
    formDataDeleteOneUser.append('userIDToDelete', secondUserID)
    Axios({
      method: 'post',
      url: `${server_app_api_php}/reactphp/index.php`,
      data: formDataDeleteOneUser,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => {
      //setHandleSubmitBtnDelete('')
      setTableRefresh('Refresh')
      alert(response.data)
      //window.location.reload()
    })

    
   
     }

  const Row = ({ index, style }) => {
    const row = DBtableViewSalesReport[index];
    const profit1 = row.unit_quantity * row.product_unit_cost;
    const profit = row.product_total_price - profit1;

    return (
      <div style={style} className="row">
        <div>{index + 1}</div>
        <div hidden={secondUserPosition === 'Cashier' || secondUserPosition === 'Manager'}>
          {row.branch_name}
        </div>
        <div>{row.pos_date}</div>
        <div>{row.product}</div>
        <div>{row.sell_type}</div>
        <div>{row.stock_quantity}</div>
        <div>{row.unit_quantity}</div>
        <div hidden={secondUserPosition === 'Cashier'}>
          {row.product_unit_cost}
        </div>
        <div>{row.product_unit_price}</div>
        <div>{row.product_total_price}</div>
        <div hidden={secondUserPosition === 'Cashier'}>
          {profit}
        </div>
        <div hidden={secondUserPosition === 'Cashier'}>
          {row.Last_name} {row.first_name}
        </div>
        <div>{row.customerPhone}</div>
        <div>{row.customer}</div>
        <div>{row.refererPhone}</div>
        <div>{row.refererName}</div>
        <div hidden={secondUserPosition !== 'Business Owner' && secondUserRole !== 'System Administrator'}>
          <span
            onClick={() => {
              deleteRecord(row.posID);
            }}
            className='fa fa-trash red-text'
            title='Delete This Record From The Database'
            disabled={handleSubmitBtnDelete === 'Loading'}
          ></span>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Headers />
      <div className="sales-report-container">
        {loading ? (
          <div>Loading...</div>
        ) : (
          <List
            height={window.innerHeight - 100} // Adjust for headers, footers, etc.
            itemCount={DBtableViewSalesReport.length}
            itemSize={50} // Adjust row height as needed
            width={window.innerWidth}
          >
            {Row} {/* Use the Row component here */}
          </List>
        )}
      </div>
    </div>
  );
};

export default SalesReport;
